import { render, staticRenderFns } from "./DinnerMenu.vue?vue&type=template&id=66e27635&scoped=true"
import script from "./DinnerMenu.vue?vue&type=script&lang=js"
export * from "./DinnerMenu.vue?vue&type=script&lang=js"
import style0 from "./DinnerMenu.vue?vue&type=style&index=0&id=66e27635&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e27635",
  null
  
)

export default component.exports